import { Sector } from "recharts";

/** Cursor em faixa para gráficos de barras/colunas (tooltip) */
export const TOOLTIP_CURSOR_BAND = { fill: "rgba(241, 245, 249, 0.92)" };

/**
 * Destaque ao passar o mouse nas barras: contorno claro + animação curta.
 * Espalhe em cada `<Bar />` com `{...BAR_HOVER_PROPS}`.
 */
export const BAR_HOVER_PROPS = {
  activeBar: {
    stroke: "#ffffff",
    strokeWidth: 2.5,
    opacity: 1,
  },
  isAnimationActive: true,
  animationDuration: 280,
} as const;

/** Extrai a linha do dataset passada ao `onClick` do `<Bar />` (Recharts 2 e 3). */
export function barRowFromClick<T>(item: unknown): T | undefined {
  if (item == null || typeof item !== "object") return undefined;
  const o = item as { payload?: T };
  if ("payload" in o && o.payload !== undefined) return o.payload;
  return item as T;
}

type DotOpts = { dotR?: number; activeR?: number };

/** Pontos de linha com halo no hover (cores por série). */
export function lineDots(strokeColor: string, opts?: DotOpts) {
  const r = opts?.dotR ?? 3.5;
  const ar = opts?.activeR ?? 7;
  return {
    dot: {
      fill: strokeColor,
      r,
      stroke: "#ffffff",
      strokeWidth: 2,
    },
    activeDot: {
      r: ar,
      stroke: "#ffffff",
      strokeWidth: 2.5,
      fill: strokeColor,
    },
  };
}

/** Linha só com pontos no hover (`dot={false}`). */
export function lineHoverOnly(strokeColor: string, opts?: { r?: number }) {
  return {
    activeDot: {
      r: opts?.r ?? 8,
      stroke: "#ffffff",
      strokeWidth: 2.5,
      fill: strokeColor,
    },
  };
}

type SectorLike = {
  cx?: number;
  cy?: number;
  innerRadius?: number;
  outerRadius?: number;
  startAngle?: number;
  endAngle?: number;
  fill?: string;
};

/** Fatia do donut/torta levemente maior no hover. */
export function PieActiveSector(props: SectorLike) {
  const {
    cx = 0,
    cy = 0,
    innerRadius = 0,
    outerRadius = 0,
    startAngle = 0,
    endAngle = 0,
    fill,
  } = props;
  return (
    <Sector
      cx={cx}
      cy={cy}
      innerRadius={innerRadius}
      outerRadius={outerRadius + 7}
      startAngle={startAngle}
      endAngle={endAngle}
      fill={fill}
      stroke="#ffffff"
      strokeWidth={2}
      style={{ filter: "drop-shadow(0 3px 6px rgba(15, 23, 42, 0.18))" }}
    />
  );
}
